module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abstract"
  }, [(_vm.children) ? _c('el-row', _vm._l((_vm.children), function(route, index) {
    return _c('el-col', {
      attrs: {
        "xs": 10,
        "sm": 8,
        "md": 6,
        "lg": 4,
        "offset": index > 0 ? 2 : 0
      }
    }, [_c('el-card', {
      attrs: {
        "body-style": {
          padding: '0px'
        }
      }
    }, [_c('div', {
      staticClass: "card-wrapper"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": route.imgUrl,
        "type": "image/webp"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('p', [_vm._v(_vm._s(route.name))]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: route.name
        }
      }
    }, [_vm._v("查看")])], 1)])])], 1)
  })) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f5c0966!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/abstract.vue
// module id = 556
// module chunks = 2